import { render, staticRenderFns } from "./table_config_column_edit.vue?vue&type=template&id=15f66e15&scoped=true"
import script from "./table_config_column_edit.vue?vue&type=script&lang=js"
export * from "./table_config_column_edit.vue?vue&type=script&lang=js"
import style0 from "./table_config_column_edit.vue?vue&type=style&index=0&id=15f66e15&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f66e15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15f66e15')) {
      api.createRecord('15f66e15', component.options)
    } else {
      api.reload('15f66e15', component.options)
    }
    module.hot.accept("./table_config_column_edit.vue?vue&type=template&id=15f66e15&scoped=true", function () {
      api.rerender('15f66e15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/metadata/table_config_column_edit.vue"
export default component.exports